var debounceTimer;
export default function (func, timeout = 300) {
  function debouncer() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      func();
    }, timeout);
  }

  return debouncer();
}
